<template>
  <div class="userMobileBody">
    <div id="userMobileWindow" class="userMobileWindow">
      <mobile-nav
        :session-history-list="sessionHistoryList"
        @getHistory="handleGetHistory"
        @newChat="handleCreateNewChat"
      />
      <div class="userBottom">
        <!--信息窗口-->
        <mobile-home-ai-chat
          v-if="showChat"
          id="userMobileMessage"
          :key="childKey"
          ref="homeMobileAiChatRef"
          :message-list="messageList"
          class="userMobileMessage"
          :session-id="sessionId"
          :channel-id="channelId"
          :init-loading="initLoading"
          :send-loading="sendMessageLoading"
          @rollbackLoading="handleLoading"
          @sendChannelId="handleChannelId"
        >
        </mobile-home-ai-chat>

        <!--底部发送-->
        <div v-if="channelId !== 3" class="customerChatFootDiv">
          <div class="customerChatTool">
            <!--发送内容-->
            <div style="height: calc(100% - 15px)">
              <input
                ref="imageInputRef"
                type="file"
                accept="image/*"
                multiple
                style="display: none"
                @change="handleImagePick"
              />
              <div v-if="imageAttachments.length > 0" class="image-attachments">
                <div
                  v-for="item in imageAttachments"
                  :key="item.id"
                  class="image-attachment"
                  :class="{ loading: item.loading }"
                >
                  <img
                    :src="item.localUrl || item.url"
                    referrerpolicy="no-referrer"
                    @click="previewInputImage(item.localUrl || item.url)"
                  />
                  <span v-if="item.loading" class="uploading-text">{{ $t("home.uploading") }}</span>
                  <button type="button" @click.stop="removeImageAttachment(item.id)">
                    &times;
                  </button>
                </div>
              </div>
              <textarea
                v-model.trim="sendData"
                class="customerChatText"
                maxlength="100"
                :placeholder="
                  isRecording ? liveTranscript || $t('home.listening') : $t('home.inputPlaceholder')
                "
                :disabled="sendMessageLoading"
                :style="sendMessageLoading ? 'cursor: not-allowed;' : ''"
                @keyup.enter.prevent="enterSendMessage"
              ></textarea>
              <button
                type="button"
                class="image-upload-btn"
                :disabled="sendMessageLoading"
                :title="$t('home.uploadImage')"
                @click="triggerImagePick"
              >
                <i class="el-icon-picture-outline"></i>
              </button>
              <!-- 停止按钮 -->
              <button v-if="sendMessageLoading" class="stop-btn" @click="handleAbort()">
                <svg viewBox="0 0 24 24">
                  <rect x="6" y="6" width="12" height="12" />
                </svg>
              </button>
              <button
                v-if="!sendMessageLoading"
                type="button"
                class="voice-btn"
                :class="{ recording: isRecording }"
                :disabled="sendMessageLoading"
                :title="$t('home.holdToSpeak')"
                @mousedown="startVoiceInput"
                @mouseup="finishVoiceInput"
                @mouseleave="cancelVoiceInput"
                @touchstart.prevent="startVoiceInput"
                @touchend.prevent="finishVoiceInput"
                @touchcancel.prevent="cancelVoiceInput"
              >
                <i class="el-icon-microphone"></i>
                <div v-if="isRecording" class="recording-pop">
                  <div class="wave-bars"><span></span><span></span><span></span><span></span></div>
                  <div>{{ liveTranscript || $t("home.listeningShort") }}</div>
                  <small>{{ recordSeconds }}s / {{ $t("home.releaseToSend") }}</small>
                </div>
              </button>
              <el-button
                v-if="!sendMessageLoading"
                type="text"
                size="mini"
                :loading="sendMessageLoading"
                :disabled="sendMessageLoading"
                icon="el-icon-s-promotion"
                class="customerChatButton"
                @click="sendMessage(sendData)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     登录-->
    <mobile-login
      :active-name="activeName"
      :show-modal="showModal"
      @closeLogin="closeLogin"
      @changeActiveName="changeActiveNameEnterprise"
    />
  </div>
</template>

<script>
import ChatApi from "@/api/chat";
import { getChannelById } from "@/constants/channel";
import SessionApi from "@/api/session";
import UserLogin from "../login/userLogin";
import ChannelDialog from "../ChannelDialog";
import HistorySession from "../HistorySession/index";
import { listToTree } from "@/utils/util";
import MobileNav from "./MobileNav";
import MobileHomeAiChat from "./MobileHomeAiChat";
import MobileLogin from "./MobileLogin";
import { ASRSession, uploadLeadsqaImage } from "@/utils/multimodal";

export default {
  name: "MobileHome",
  components: {
    MobileLogin,
    MobileHomeAiChat,
    MobileNav,
    HistorySession,
    ChannelDialog,
    UserLogin,
  },
  data() {
    return {
      childKey: 0,
      showChat: true,
      chatActive: true,
      showInit: true,
      uploadImg: {},
      isFirst: true,
      showHistoryDialog: false,
      sendMessageLoading: false,
      sessionHistoryList: [],
      query: {
        page: 0,
        size: 1000,
        total: 0,
      },
      showChannelDialog: false,
      sessionId: null,
      channelId: null,
      messageList: [],
      sendData: "",
      maxImageCount: 3,
      imageAttachments: [],
      asrSession: null,
      isRecording: false,
      liveTranscript: "",
      recordSeconds: 0,
      recordTimer: null,
      initLoading: true,
      activeName: "", // 登录tabs栏的切换状态
      showModal: false,
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    isLogin() {
      return this.$store.state.user.userId != null;
    },
  },
  mounted() {
    // 设置 viewport meta 标签
    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    document.head.appendChild(meta);

    // 添加手势事件监听
    document.addEventListener("gesturestart", this.preventZoom);
    this.initialization();
  },
  beforeDestroy() {
    // 清理事件监听
    document.removeEventListener("gesturestart", this.preventZoom);
    this.clearVoiceInput();
    this.imageAttachments.forEach((item) => {
      if (item.localUrl) {
        URL.revokeObjectURL(item.localUrl);
      }
    });
  },
  methods: {
    handleAbort() {
      this.$refs.homeMobileAiChatRef.handleAbort();
    },
    preventZoom(e) {
      e.preventDefault(); // 禁止双指缩放
    },
    ensureLogin() {
      if (this.isLogin) {
        return true;
      }
      window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
      return false;
    },
    async checkImages(images) {
      const rightImages = [];
      if (images && images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          try {
            const res = await fetch(images[i]);
            if (res.status === 200) {
              const imageBlob = await res.blob();
              if (imageBlob.size > 100) {
                rightImages.push(images[i]);
              }
            }
          } catch (e) {}
        }
      }
      return rightImages;
    },
    async reStarChat() {
      this.sendMessageLoading = true;
      this.showChat = false;
      setTimeout(() => {
        this.showChat = true;
        this.childKey += 1;
      });
    },
    handleChannelId(channelId) {
      this.channelId = channelId;
      this.getSessionHistory();
    },
    handleOpenElement() {
      window.location.href = "/element";
    },
    async handleCreateNewChat() {
      if (!this.ensureLogin()) {
        return;
      }
      await this.reStarChat();
      this.isFirst = true;
      await this.createSession();
      this.sendMessageLoading = false;
    },
    handleLoading(val) {
      this.sendMessageLoading = val;
    },
    async initialization() {
      if (!this.isLogin) {
        // 未登录
        await this.createSession();
      } else {
        const params = this.$route.params;
        const sessionId = params.sessionId;
        // 同步执行，查询最新
        await this.getSessionHistory();
        if (!sessionId) {
          // 新会话
          await this.createSession();
          return;
        }
        await this.handleGetHistory(sessionId);
      }
    },
    async handleGetHistory(sessionId) {
      await this.reStarChat();
      this.isFirst = true;
      this.sessionId = sessionId;
      this.sessionHistoryList.forEach((item) => {
        if (sessionId === item.id) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      // 获取用户最新的一个会话，获取信息并展示
      const res = await this.axios.get(ChatApi.getChatHistory, { params: { sessionId } });
      if (res && res.length > 0) {
        this.channelId = res[res.length - 1].channelId;
        await this.$refs.homeMobileAiChatRef.handleEditInitShow(false);
        for (const item of res) {
          item.isCopy = false;
          // messageStatus: 0=未评价, 1=不喜欢, 2=喜欢 → like: null=未评价, 0=喜欢, 1=不喜欢
          if (item.messageStatus === 2) {
            item.like = 0;
          } else if (item.messageStatus === 1) {
            item.like = 1;
          } else {
            item.like = null;
          }
          if (item.isPdf && item.pdfPath) {
            const pdfImages = item.pdfPath.split(",");
            const rightImages = await this.checkImages(pdfImages);
            if (rightImages.length > 0) {
              item.pdfPath = rightImages;
            } else {
              item.pdfPath = "";
            }
          } else {
            item.pdfPath = "";
          }
          item.citePath = JSON.parse(item.citePath);
          // 解析 file_list JSON 字符串
          if (item.file_list && typeof item.file_list === 'string') {
            try {
              item.file_list = JSON.parse(item.file_list);
            } catch (e) {
              item.file_list = [];
            }
          }
          // 拼接 OSS URL
          let ossBaseUrl = (process.env.VUE_APP_OSS_URL || 'https://dq123oss.dq123.com').replace(/\/+$/, '');
          if (ossBaseUrl) {
            ossBaseUrl = ossBaseUrl + '/';
          }
          // 处理 file_list 字段，拼接 OSS URL，并将图片提取到 imageUrls
          if (item.file_list && Array.isArray(item.file_list)) {
            item.file_list = item.file_list.map(file => ({
              ...file,
              url: ossBaseUrl + (file.oss_path || '').replace(/^\/+/, ''),
            }));
            // 将 file_list 中 kind=image 的项提取到 imageUrls，确保历史图片能正常显示
            item.imageUrls = item.file_list
              .filter(file => file.kind === 'image' && file.url)
              .map(file => file.url);
          }
        }
        const homeMobileAiChatDiv = document.getElementById("userMobileMessage");
        if (this.channelId === 3) {
          homeMobileAiChatDiv.style.height = "100%";
          this.sendMessageLoading = true;
          const obj = Object.assign({
            channelId: this.channelId,
            sessionId: sessionId,
            title: this.$t("chat.title.canGenerateForm"),
            sendTime: this.$options.filters.formatDate(new Date()),
            roleType: "bomForm",
          });
          res.push(obj);
        } else {
          homeMobileAiChatDiv.height = "calc(100% - 100px)";
          if (this.channelId) {
            // 获取对应渠道的配置问题
            const channelRes = getChannelById(this.channelId);
            if (channelRes.message) {
              const message = JSON.parse(channelRes.message);
              const obj = Object.assign({
                channelId: this.channelId,
                sessionId: sessionId,
                title: this.$t("chat.title.tryAsk"),
                questions: message,
                sendTime: this.$options.filters.formatDate(new Date()),
                roleType: "more",
              });
              res.push(obj);
            }
          }
        }
        this.messageList = listToTree(res, { idKey: "id", parentKey: "parentId" });
        this.toBottom(200);
      } else {
        this.messageList = [];
        // 获取该渠道下的热门问题
        await this.$refs.homeMobileAiChatRef.handleEditInitShow(true);
      }
      this.initLoading = false;
      this.sendMessageLoading = false;
    },
    // 生成会话id
    async createSession() {
      const res = await this.axios.get(SessionApi.createSession);
      if (res) {
        this.$router.push({ name: "home" }).catch(() => {});
        this.sessionId = res;
        this.channelId = null;
        this.messageList = [];
        // 获取该渠道下的热门问题
        await this.$refs.homeMobileAiChatRef.handleEditInitShow(true);
        this.initLoading = false;
      }
    },
    // 获取历史会话
    async getSessionHistory() {
      const that = this;
      const res = await that.axios.get(SessionApi.getSessionHistory, { params: this.query });
      res.content.forEach((item, index) => {
        item.active = false;
        item.showEdit = false;
      });
      that.sessionHistoryList = res.content;
      that.query.total = res.totalElements;
      if (that.query.total) {
        this.showHistoryDialog = true;
      }
    },
    enterSendMessage(event) {
      event.preventDefault();
      // if (event.ctrlKey) {
      //   this.sendData += '\n';
      //   return;
      // }
      if (this.sendMessageLoading) {
        return;
      }
      this.sendMessage(this.sendData);
    },
    triggerImagePick() {
      if (!this.ensureLogin()) {
        return;
      }
      if (!this.sendMessageLoading && this.$refs.imageInputRef) {
        this.$refs.imageInputRef.click();
      }
    },
    async handleImagePick(event) {
      if (!this.ensureLogin()) {
        event.target.value = "";
        return;
      }
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      let hasExceededLimit = false;
      for (const file of files) {
        if (this.imageAttachments.length >= this.maxImageCount) {
          hasExceededLimit = true;
          break;
        }
        if (!file.type.startsWith("image/")) {
          this.$message.warning(`请选择图片文件：${file.name}`);
          continue;
        }
        const item = {
          id: `${Date.now()}-${Math.random()}`,
          name: file.name,
          localUrl: URL.createObjectURL(file),
          url: "",
          fileInfo: null,
          loading: true,
        };
        this.imageAttachments.push(item);
        try {
          const fileInfo = await uploadLeadsqaImage(file, {
            sendId: this.userId,
            source: 2,
          });
          item.fileInfo = fileInfo;
          item.url = fileInfo.url;
          item.loading = false;
        } catch (error) {
          this.removeImageAttachment(item.id);
          this.$message.error(error.message || "图片上传失败");
        }
      }
      if (hasExceededLimit) {
        this.$message.warning("已超过上传图片数量 请删减！");
      }
    },
    removeImageAttachment(id) {
      const index = this.imageAttachments.findIndex((item) => item.id === id);
      if (index === -1) {
        return;
      }
      const [item] = this.imageAttachments.splice(index, 1);
      if (item.localUrl) {
        URL.revokeObjectURL(item.localUrl);
      }
    },
    previewInputImage(url) {
      this.$refs.homeMobileAiChatRef.$refs.viewPicture.openView(1, url, false);
    },
    async startVoiceInput() {
      if (!this.ensureLogin()) {
        return;
      }
      if (this.isRecording || this.sendMessageLoading) {
        return;
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message.warning("当前浏览器不支持录音");
        return;
      }
      this.isRecording = true;
      this.liveTranscript = "";
      this.recordSeconds = 0;
      this.asrSession = new ASRSession({
        sendId: this.userId,
        source: 2,
        onPartial: (text) => {
          this.liveTranscript = text;
        },
        onFinal: (text) => {
          this.liveTranscript = text;
        },
        onError: (message) => {
          this.$message.warning(message || "语音识别异常");
        },
      });
      try {
        await this.asrSession.start();
      } catch (error) {
        this.$message.warning(
          error.message === "ws error" ? "无法建立语音识别连接" : "麦克风访问失败"
        );
        this.clearVoiceInput();
        return;
      }
      this.recordTimer = setInterval(() => {
        this.recordSeconds += 1;
        if (this.recordSeconds >= 60) {
          this.finishVoiceInput();
        }
      }, 1000);
    },
    async finishVoiceInput() {
      if (!this.isRecording) {
        return;
      }
      const asrSession = this.asrSession;
      this.isRecording = false;
      if (this.recordTimer) {
        clearInterval(this.recordTimer);
        this.recordTimer = null;
      }
      let result = { text: this.liveTranscript, hasAudio: true };
      try {
        result = await asrSession.stop();
      } catch (error) {
        // keep the best-effort transcript already displayed
      }
      this.asrSession = null;
      const text = (result.text || "").trim();
      if (!result.hasAudio || !text) {
        this.$message.warning("未识别到语音，请重新长按说话");
        this.liveTranscript = "";
        this.recordSeconds = 0;
        return;
      }
      this.sendData = this.sendData ? `${this.sendData} ${text}` : text;
      this.liveTranscript = "";
      this.recordSeconds = 0;
    },
    cancelVoiceInput() {
      if (!this.isRecording) {
        return;
      }
      this.clearVoiceInput();
    },
    clearVoiceInput() {
      if (this.recordTimer) {
        clearInterval(this.recordTimer);
        this.recordTimer = null;
      }
      if (this.asrSession) {
        this.asrSession.close();
        this.asrSession = null;
      }
      this.isRecording = false;
      this.liveTranscript = "";
      this.recordSeconds = 0;
    },
    // 消息发送
    async sendMessage(data) {
      if (!this.ensureLogin()) {
        return;
      }
      // 判断空
      const readyImages = this.imageAttachments.filter((item) => item.url).map((item) => item.url);
      const readyFileList = this.imageAttachments
        .filter((item) => item.fileInfo)
        .map((item) => item.fileInfo);
      if (this.imageAttachments.some((item) => item.loading)) {
        this.$message.warning("图片仍在上传，请稍后发送");
        return;
      }
      if (!data && readyImages.length < 1) {
        this.$message.warning("发送内容不能为空");
        this.sendData = "";
        return;
      }
      this.sendMessageLoading = true;
      // 存入自己的消息列表
      const obj = Object.assign({
        channelId: this.channelId,
        sessionId: this.sessionId,
        sendMessage: data || "请识别图片内容",
        imageUrls: readyImages,
        file_list: readyFileList,
        sendTime: this.$options.filters.formatDate(new Date()),
        roleType: 2,
      });
      this.messageList.push(obj);
      this.sendData = "";
      this.imageAttachments.forEach((item) => {
        if (item.localUrl) {
          URL.revokeObjectURL(item.localUrl);
        }
      });
      this.imageAttachments = [];
      this.toBottom(200);
      // 子组件发送ai请求
      if (this.isFirst) {
        this.$refs.homeMobileAiChatRef.handleEditInitShow(false);
      }
      // if ((data.indexOf('上传') > -1 || data.indexOf('识别') > -1) && data.indexOf('表格') > -1) {
      //   let obj = Object.assign({
      //     channelId: 3,
      //     sessionId: this.sessionId,
      //     sendTime: this.$options.filters['formatDate'](new Date),
      //     roleType: 'upload',
      //   });
      //   this.messageList.push(obj);
      // } else {
      //   await this.$refs.homeMobileAiChatRef.aiReply(obj);
      // }
      await this.$refs.homeMobileAiChatRef.aiReply(obj);
      if (this.isFirst) {
        this.isFirst = false;
        this.getSessionHistory();
      }
      this.sendMessageLoading = false;
    },

    // axios发送消息给客服
    async sendMessageToService(obj) {
      await this.axios
        .post(ChatApi.sendMessage, obj)
        .then((res) => {
          this.sendMessageLoading = false;
        })
        .catch((error) => {
          if (error.message === "该会话已断开连接！") {
            this.handleFinishService();
          }
        });
    },

    // 回到底部
    toBottom(time) {
      setTimeout(() => {
        const RightCont = document.getElementById("userMobileMessage");
        if (RightCont != null) {
          const scrollHeight2 = RightCont.scrollHeight;
          RightCont.scrollTop = scrollHeight2;
        }
      }, time);
      clearTimeout();
    },

    // 退出登录
    handleLoginOut() {
      this.$store.dispatch("user/logout");
    },
    // 改变登录tab栏的状态 -- 企业
    changeActiveNameEnterprise() {
      this.activeName = "second";
    },
    // 登录弹出框的x符号
    closeLogin() {
      this.showModal = false;
      this.$store.dispatch("login/closeLoginDialog");
    },
  },
};
</script>

<style scoped lang="scss">
.userMobileBody {
  touch-action: manipulation; /* 禁止缩放 */
  -ms-touch-action: manipulation; /* IE 兼容 */
  background: linear-gradient(180deg, rgba(230, 238, 254, 1) 0%, rgba(240, 241, 254, 1) 100%);
  font-size: 14px;
  color: #000000;
  width: 100%;
  height: 100%;
  z-index: -999;

  /* 停止按钮样式 */
  .stop-btn {
    position: absolute;
    bottom: 0px;
    right: 10px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: none;
    background-color: #e74c3c; /* 红色背景 */
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* 按钮悬停效果 */
  .stop-btn:hover {
    background-color: #c0392b; /* 深色变体 */
  }

  /* 停止按钮的 SVG 图标 */
  .stop-btn svg {
    width: 15px;
    height: 15px;
    fill: white;
  }

  .user-history-info {
    margin-top: 30px;
    cursor: pointer;
    padding: 0 10px;
    background-color: #f7f7f7;
    border-radius: 8px;
    color: #333333;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:active {
      background-color: #e0e0e0;
    }
  }

  .userMobileWindowHeader {
    height: 60px;
    border: 1px solid #dddddd;
  }

  .userMobileWindow {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    display: flex;
    flex-direction: column;

    .userBottom {
      background-color: #ffffff;
      height: calc(100% - 60px);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .userMobileMessage {
        overflow-y: auto;
        padding: 10px;
        width: 100%;
        margin-bottom: 10px;
        height: calc(100% - 100px);
        word-wrap: break-word;
        border-radius: 10px;
      }

      .customerChatFootDiv {
        width: 85%;
        position: fixed;
        bottom: 25px;
        z-index: 1111;
        background: #fff;
        border: 1px solid #ff6a00;
        box-sizing: border-box;
        padding: 5px;
        height: 70px;
        border: 1px solid #ff6a00;
        box-shadow: 0 3px 5px rgb(199 199 199 / 40%);
        border-radius: 10px;

        .customerChatTool {
          position: relative;
          height: 100%;

          .customerChatToolList {
            width: 100%;
            height: 45px;
            padding: 0 10px;
            border: 1px solid #dddddd;
            color: gray;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .customerChatText {
            width: 99%;
            height: 100%;
            border: none;
            outline: none;
            padding: 10px 86px 24px 38px;
            box-sizing: border-box;
            resize: none;
          }

          .image-attachments {
            position: absolute;
            left: 6px;
            right: 6px;
            top: -54px;
            display: flex;
            gap: 8px;
            padding: 6px;
            overflow-x: auto;
            background: rgba(255, 255, 255, 0.94);
            border: 1px solid #f1d2bd;
            border-radius: 10px;
            box-shadow: 0 4px 12px rgb(199 199 199 / 28%);
          }

          .image-attachment {
            position: relative;
            width: 40px;
            height: 40px;
            flex: 0 0 auto;
            border-radius: 8px;
            overflow: hidden;
            background: #fff4ec;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .uploading-text {
              position: absolute;
              inset: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: #ffffff;
              background: rgba(0, 0, 0, 0.45);
            }

            button {
              position: absolute;
              top: -2px;
              right: -2px;
              width: 18px;
              height: 18px;
              border: none;
              border-radius: 50%;
              color: #ffffff;
              background: rgba(0, 0, 0, 0.58);
            }
          }

          .image-upload-btn,
          .voice-btn,
          .customerChatButton {
            position: absolute;
            width: 28px;
            height: 28px;
            min-width: 28px;
            padding: 0;
            border: none;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ff6a00;
            background: linear-gradient(180deg, #fff8f3 0%, #fff0e6 100%);
            box-shadow: 0 2px 8px rgba(255, 106, 0, 0.12);
            font-size: 16px;
            line-height: 28px;
            transition: all 0.18s ease;
          }

          .image-upload-btn:active,
          .voice-btn:active,
          .customerChatButton:active {
            color: #ffffff;
            background: #ff6a00;
            transform: scale(0.96);
          }

          .image-upload-btn:disabled,
          .voice-btn:disabled,
          .customerChatButton.is-disabled {
            color: #c0c4cc;
            background: #f4f4f5;
            box-shadow: none;
          }

          .image-upload-btn {
            left: 6px;
            bottom: 1px;
          }

          .voice-btn {
            right: 36px;
            bottom: 1px;
          }

          .voice-btn.recording {
            color: #ffffff;
            background: #ff6a00;
            box-shadow: 0 0 0 6px rgba(255, 106, 0, 0.14);
          }

          .recording-pop {
            position: absolute;
            right: 0;
            bottom: 34px;
            width: 210px;
            padding: 10px;
            line-height: 20px;
            border-radius: 12px;
            color: #333333;
            background: #ffffff;
            border: 1px solid #f1d2bd;
            box-shadow: 0 8px 22px rgb(199 199 199 / 35%);
            text-align: center;
            pointer-events: none;
          }

          .wave-bars {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 4px;
            margin-bottom: 8px;

            span {
              width: 4px;
              height: 12px;
              border-radius: 10px;
              background: #ff6a00;
              animation: voice-wave 0.8s ease-in-out infinite;
            }

            span:nth-child(2) {
              animation-delay: 0.1s;
            }

            span:nth-child(3) {
              animation-delay: 0.2s;
            }

            span:nth-child(4) {
              animation-delay: 0.3s;
            }
          }

          @keyframes voice-wave {
            0%,
            100% {
              transform: scaleY(0.65);
            }
            50% {
              transform: scaleY(1.45);
            }
          }

          .customerChatButton {
            bottom: 1px;
            right: 0px;
          }
        }
      }
    }
  }
}
</style>
